import React, { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AuthActionIcon, PaymentSettingsIcon } from '../icons';
import { useHeader } from './HeaderContext';

const AccountPersonaMenu = () => {
    const auth0 = useAuth0();
    const { openPaymentSettings } = useHeader();
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
                setDropdownOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const handlePaymentSettings = () => {
        setDropdownOpen(false);
        openPaymentSettings();
    };

    const handleLogout = () => {
        setDropdownOpen(false);
        auth0.logout({ logoutParams: { returnTo: window.location.origin } });
    };

    const initials = auth0.user?.name
        ?.split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase() ?? '?';

    if (!auth0.isAuthenticated || !auth0.user) return null;

    return (
        <div className="avatar-dropdown-wrapper" ref={dropdownRef}>
            <div
                className={`avatar${dropdownOpen ? ' open' : ''}`}
                onClick={() => setDropdownOpen(prev => !prev)}
                aria-haspopup="true"
                aria-expanded={dropdownOpen}
                title="Account settings"
            >
                {initials}
            </div>

            {dropdownOpen && (
                <div className="avatar-dropdown" role="menu">
                    <div className="dropdown-header">
                        <div className="dropdown-name">{auth0.user.name}</div>
                        <div className="dropdown-email">{auth0.user.email}</div>
                    </div>

                    <div className="dropdown-section">
                        <button
                            className="dropdown-item"
                            onClick={handlePaymentSettings}
                            role="menuitem"
                        >
                            <PaymentSettingsIcon size={15} />
                            Payment settings
                        </button>
                    </div>

                    <div className="dropdown-divider" />

                    <div className="dropdown-section">
                        <button
                            className="dropdown-item danger"
                            onClick={handleLogout}
                            role="menuitem"
                        >
                            <AuthActionIcon size={15} />
                            Logout
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AccountPersonaMenu;